var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { createElement, isValidElement, Fragment } from 'react';
// @ts-ignore
import { PART_TYPE, IntlMessageFormat } from 'intl-messageformat';
/**
 * React node 插值支持
 */
export function supportReactNodeInterpolation(i18n) {
    var oldT = i18n.t.bind(i18n);
    i18n.t = function (keys, options, fallbackText) {
        var _a;
        var reactNodeInterpolates = Object.entries(options || {})
            .map(function (_a) {
            var key = _a[0], val = _a[1];
            return (isValidElement(val) ? key : null);
        })
            .filter(function (i) { return !!i; });
        // 不存在 React Node 插值
        if (!reactNodeInterpolates.length) {
            return oldT(keys, options, fallbackText);
        }
        try {
            var i18nOptions = i18n.i18nInstance.instance.options || {};
            var ns_1 = (options || {}).ns || i18nOptions.ns || 'translation';
            ns_1 = Array.isArray(ns_1) ? ns_1[0] : 'translation';
            var getTargetText_1 = function (lang) {
                return i18n.i18nInstance.instance.getResource(lang, ns_1, keys);
            };
            var fallbackLng_1 = i18nOptions.fallbackLng;
            // 判断 fallbacklng 类型
            var judgeType_1 = function () {
                if (!fallbackLng_1)
                    return 'null';
                if (Array.isArray(fallbackLng_1) && fallbackLng_1.length) {
                    return 'array';
                }
                return typeof fallbackLng_1;
            };
            var fallbackTarget = function () {
                var targetText;
                switch (judgeType_1()) {
                    // 二层兜底
                    // fallbackLng：['zh','en'] : zh -> en 的顺序
                    case 'array':
                        ;
                        fallbackLng_1.find(function (lang) { return (targetText = getTargetText_1(lang)); });
                        break;
                    case 'function':
                        var fallbacks = fallbackLng_1(i18n.language);
                        if (!Array.isArray(fallbacks)) {
                            console.error('fallbackLng must be return array');
                            // 函数格式下，若非格式返回，直接走第三层兜底
                            return fallbackText || keys;
                        }
                        ;
                        fallbacks.find(function (lang) { return (targetText = getTargetText_1(lang)); });
                }
                // 三层兜底
                if (targetText === undefined)
                    targetText = fallbackText || keys;
                return targetText;
            };
            var targetText = getTargetText_1(i18n.language) || fallbackTarget();
            if (Array.isArray(targetText))
                targetText = targetText[0];
            var mf = new IntlMessageFormat(targetText, i18n.language, {}, {
                ignoreTag: !!((_a = i18nOptions.formatOptions) === null || _a === void 0 ? void 0 : _a.ignoreTag)
            });
            try {
                var parts = mf.formatToParts(options);
                if (parts.length === 1) {
                    return parts[0].value;
                }
                var result = parts.reduce(function (all, part) {
                    if (!all.length ||
                        part.type !== PART_TYPE.literal ||
                        typeof all[all.length - 1] !== 'string') {
                        all.push(part.value);
                    }
                    else {
                        all[all.length - 1] += part.value;
                    }
                    return all;
                }, []);
                return createElement.apply(void 0, __spreadArray([Fragment, {}], result, false));
            }
            catch (err) {
                console.warn("[intl-react-plugin] Key ".concat(JSON.stringify(keys), " has missing some interpolation, use fallback target text ").concat(JSON.stringify(targetText), " fallback. More: ").concat(err));
                // 传入的有组件，拿到的一定是组件
                var fallback = oldT(keys, options, fallbackText);
                return createElement(Fragment, {}, fallback);
            }
        }
        catch (err) {
            console.error('[intl-react-plugin] Some error occurred', err);
            return oldT(keys, options, fallbackText);
        }
    };
}
//# sourceMappingURL=interpolation.js.map